import { Component, Input, OnChanges, ViewChild } from '@angular/core';
import { MatTable, MatTableModule } from '@angular/material/table';
import { FormatDateTimePipe, PackageChangeHistoryDto } from '@ottobock/remote-update/domain';

@Component({
  selector: 'remote-update-feature-remote-update-dashboard-change-history-table',
  templateUrl: './change-history-table.component.html',
  styleUrl: './change-history-table.component.css',
  imports: [MatTableModule, FormatDateTimePipe]
})
export class ChangeHistoryTableComponent implements OnChanges {
  @ViewChild(MatTable) table!: MatTable<PackageChangeHistoryDto>;

  @Input() data: PackageChangeHistoryDto[] = [];

  displayedColumns = ['event', 'user', 'timestamp', 'remarks'];

  ngOnChanges(): void {
    if (this.data && this.data.length > 0) {
      this.data = [...this.data].sort(
        (a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
      );
    }
  }
}
